import ReactMarkdown from "react-markdown";
import type { ContentPageDefinition } from "@/content/content-pages";

type MarkdownContentPageProps = {
  content: ContentPageDefinition;
};

export function MarkdownContentPage({ content }: MarkdownContentPageProps) {
  return (
    <section className="content-page d8-reveal revealed d8-reveal-delay-1">
      <header className="content-page-header">
        <h1 className="content-page-title">{content.title}</h1>
        {content.lastUpdated ? (
          <p className="content-page-updated">Last updated: {content.lastUpdated}</p>
        ) : null}
      </header>

      <article className="content-markdown">
        <ReactMarkdown>{content.markdown}</ReactMarkdown>
      </article>
    </section>
  );
}
